import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import BottomStickyBlock from '@r1-frontend/ui-react/components/BottomStickyBlock';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';
import { useOnceExecute } from '@r1-frontend/shared/hooks/useOnceExecute';

import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import OrderSummary from '~/src/features/full-buy/containers/OrderSummary';
import TotalSummary from '~/src/features/full-buy/containers/TotalSummary';
import PromoCode from '~/src/features/full-buy/PromoCode';
import { TState } from '~/src/store';

import * as ST from './styled';

interface IProps {
    withPromocode?: boolean,
}

export const TiketContainer = ({ withPromocode = true }: IProps): JSX.Element => {
    const analytics = useAnalytics();

    const {
        agreementData,
    } = useSelector((state: TState) => ({
        agreementData: state.fullBuy.agreement,
    }), shallowEqual);

    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);

    const onOpenBottomSticky = useOnceExecute(() => {
        analytics.summary.clickOpenBottomStickySummary();
    });

    return (
        <>
            {isLaptop &&
                <BottomStickyBlock
                    InnerComponent={() => (
                        <ST.BottomStickyOrderSummaryWrapper>
                            <OrderSummary/>
                            {withPromocode && <PromoCode hasAgreement={!!agreementData?.agreementId}/>}
                        </ST.BottomStickyOrderSummaryWrapper>
                    )}
                    OuterComponent={TotalSummary}
                    onOpen={onOpenBottomSticky}
                />
            }

            {!isLaptop &&
                <ST.OrderSummaryWrapper>
                    <OrderSummary/>
                    {withPromocode && <PromoCode hasAgreement={!!agreementData?.agreementId}/>}
                </ST.OrderSummaryWrapper>

            }
        </>
    );
};
